<span class="bg-light-{{color}} text-{{color}} mat-body-2 f-w-500 p-x-8 p-y-4 f-s-12 rounded-pill">
  {{ text }}
</span>
